export const isValidArrayIndex = (payload: number): boolean => payload === 0 || payload > 0;
